module.exports={author:"Daniel Borzutzky",date:"06/30/2021",publishDate:"06/30/2021",highlighted:!1,tags:"",badge:"",title:"Poem #1209 {In the Penal Colony}"};